import React from "react";
import styles from "../FreeAccount/FreeAccount.module.css";
import { useState, useEffect } from "react";
import Modal from "../Modal/Modal";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import { sendEmail, verifyEmailOtp } from "../../../lib/Store";
import { useRef } from "react";
import useUTMParams from "../../../hook/useUTMParams";
import useUserDeviceInfo from "../../../hook/useUserDeviceInfo";
const FreeAccount = ({ closeModal, coming }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [email, setEmail] = useState(sessionStorage.getItem("email") || "");
  const [loading, setLoading] = useState(false);
  const [errMsg, setErrMsg] = useState("");
  const [resendTimer, setResendTimer] = useState(0);
  const [resendEndTime, setResendEndTime] = useState(null);
  const [isResendDisabled, setIsResendDisabled] = useState(false);
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [isOtp, setIsOtp] = useState(false);
  const inputRefs = useRef([]);
  const utm_data = useUTMParams();
  const environmentInfo = useUserDeviceInfo();

  const listRef = useRef(null);
  const isAndroidApp = () => /Android/i.test(navigator.userAgent) && window.ReactNativeWebView;
  const isIOSApp = () => /iPhone|iPad|iPod/i.test(navigator.userAgent) && window.webkit;
  const isIphone = /iPhone|iPod/i.test(navigator.userAgent);
  const handleFocus = (e) => {
    if (isAndroidApp() || isIOSApp()) {
      setTimeout(() => {
        // Method 1: Smooth scroll to element
        e.target.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
      }, 300);
    }
  };
  const scrollListIntoView = () => {
    if (listRef.current) {
      listRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center"
      });
    }
  };
  useEffect(() => {
    if (!resendEndTime) return;

    const interval = setInterval(() => {
      const timeLeft = Math.max(
        0,
        Math.floor((resendEndTime - Date.now()) / 1000)
      );
      setResendTimer(timeLeft);

      if (timeLeft <= 0) {
        setIsResendDisabled(false);
        setResendEndTime(null);
        clearInterval(interval);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [resendEndTime]);
  const handleCreateAccount = async () => {
    setErrMsg("");
    const trimmed = email.trim();
    const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmed);

    if (!isValidEmail) {
      setErrMsg("Please enter a valid email address.");
      return;
    }
    sessionStorage.setItem("email", email);

    try {
      setLoading(true);
      const res = await sendEmail(trimmed, utm_data ? utm_data : null, environmentInfo);

      setIsOtp(true);
      setIsResendDisabled(true);
      //  Success: OTP sent successfully
      if (res?.status === 200 && res?.data?.status !== 409) {
        // window.open(
        //   `${process.env.REACT_APP_NAVIGATION_LOGIN}/signup?otp-not-required&email=${trimmed}`,
        //   "_blank"
        // );
        // return;
        const endTime = Date.now() + 300 * 1000;
        setResendEndTime(endTime);
        setIsResendDisabled(true);
      } else {
        const message =
          res?.response?.data?.error ||
          res?.response?.data?.error ||
          "OTP sent. Please check your email.";

        setErrMsg(message);
        setErrMsg(message);

        // Wait 2s before redirecting
        // setTimeout(() => {
        //   window.open(
        //     `${process.env.REACT_APP_NAVIGATION_LOGIN}/signup?otp-not-required&email=${trimmed}`,
        //     "_blank"
        //   );
        // }, 2000);

        return;
      }
    } catch (e) {
      console.error("sendEmail failed:", e);
      console.log("handle");
      //  Handle 409 (OTP already sent or user exists)
      if (e?.response?.status === 409) {
        console.log("handle");
        const message =
          e?.response?.data?.error ||
          "OTP already sent. Please check your email.";

        setErrMsg(message);

        // // Wait 2s before redirecting
        // setTimeout(() => {
        //   window.open(
        //     `${process.env.REACT_APP_NAVIGATION_LOGIN}/signup?otp-not-required&email=${trimmed}`,
        //     "_blank"
        //   );
        // }, 2000);

        return;
      }

      //  Handle all other errors
      const errorMessage =
        e?.response?.data?.error ||
        e?.response?.data?.message ||
        e?.message ||
        "Something went wrong. Please try again.";
      setErrMsg(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);
    try {
    } catch (error) { }
    let res = await verifyEmailOtp(email, otp);
    console.log({ res });

    if (res?.token) {
      closeModal();
      setIsOtp(false);
      setEmail("");
      setOtp(new Array(6).fill(""));

      sessionStorage.removeItem("email");

      window.location.href = `${process.env.REACT_APP_NAVIGATION_LOGIN}/?token=${res.token}&verifiedDetails=${res.user?.verifyDetails}`;
    }
    if (res?.response?.data?.error) {
      setErrMsg(res?.response?.data?.error);
      console.log(res?.response?.data?.error);
    }

    setLoading(false);
  };

  const handleOtpChange = (value, index) => {
    if (!/^[0-9]?$/.test(value)) return; // only allow digits

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    // Automatically focus next input when a digit is typed
    if (value && index < 5) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  // Handles backspace → go to previous box
  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };

  // const isOtpComplete = otp.join("").length === 6;
  return (
    <div>
      <div className={styles.PhoneContainer}>
        <div className={styles.phoneFrame}>
          <div className={styles.card}>
            {/* Logo */}
            <div className={styles.logo}>
              <img src="Svg/rexpt-logo.svg" alt="rexpt-logo" />
            </div>

            <hr className={styles.divider} />
            {!isOtp ? (
              <>
                <h2 className={styles.heading}>
                  <p>Get started for</p>
                  FREE, Signup
                  <br />
                  under 3 minutes
                </h2>
                <p className={styles.subText}>
                  If it does not exist, We will create a <b>New FREE Account</b>{" "}
                  for you.
                </p>
                <p className={styles.subText}>
                  Make sure the email ID provided is correct.
                </p>

                {/* Input */}
                <div className={styles.InputDiv}>
                  <input
                    type="email"
                    placeholder="Johnvick@gmail.com"
                    className={styles.input}
                    value={email}
                    onFocus={((e) => {

                      if (isIphone) {
                        // handleIOSFocus(e);
                      } else {
                        handleFocus(e)
                        setTimeout(scrollListIntoView, 300);
                      }


                    })

                    }
                     onBeforeInput={(e) => {
      if (e.data === " ") e.preventDefault();
    }}
                    onClick={(e) => {

                      if (isIphone) {
                        // handleIOSFocus(e);
                      } else {
                        handleFocus(e)
                        setTimeout(scrollListIntoView, 300);
                      }
                    }}
                    onChange={(e) => setEmail(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === " ") e.preventDefault(); // ⛔ block pressing space
                      if (!loading && e.key === "Enter") handleCreateAccount();
                    }}
                  />

                  {errMsg ? (
                    <p
                      id="email-error"
                      className={styles.errorText}
                      role="alert"
                    >
                      {errMsg}
                    </p>
                  ) : null}
                </div>

                {/* Button */}
                <div
                  className={styles.btn}
                  onClick={loading ? undefined : handleCreateAccount}
                >
                  <img src="Svg/btn-shape.svg" alt="btn-shape" />
                  <p>
                    {loading ? (
                      "Processing..."
                    ) : (
                      <>
                        Create my <b>FREE</b> accounts
                      </>
                    )}
                  </p>
                </div>
              </>
            ) : (
              <>
                {email && (
                  <p className={styles.codeText}>
                    Email has been sent to <strong>{email}</strong>
                  </p>
                )}
                <p className={styles.codeText}>
                  Enter the code sent to your email
                </p>

                <div className={styles.otpContainer}>
                  {[...Array(6)].map((_, i) => (
                    <input
                      key={i}
                      ref={(el) => (inputRefs.current[i] = el)}
                      value={otp[i] || ""}
                      onChange={(e) => handleOtpChange(e.target.value, i)}
                      onKeyDown={(e) => handleKeyDown(e, i)}
                      maxLength="1"
                      className={styles.otpInput}
                      inputMode="numeric"
                      type="tel"
                      onInput={(e) => {
                        e.target.value = e.target.value.replace(/[^0-9]/g, "");
                      }}
                      onFocus={((e) => {

                        if (isIphone) {
                          // handleIOSFocus(e);
                        } else {
                          handleFocus(e)
                          setTimeout(scrollListIntoView, 300);
                        }


                      })

                      }
                      onClick={(e) => {

                        if (isIphone) {
                          // handleIOSFocus(e);
                        } else {
                          handleFocus(e)
                          setTimeout(scrollListIntoView, 300);
                        }
                      }}

                    />
                  ))}
                </div>

                <p className={styles.SpamMessage}>
                  Please check your spam folder if you don’t find it in your
                  main inbox.
                </p>
                <div className={styles.resendContainer}>
                  <button
                    type="button"
                    className={styles.resendButton}
                    onClick={handleCreateAccount}
                    disabled={isResendDisabled}
                    style={{
                      cursor: isResendDisabled ? "not-allowed" : "pointer",
                      opacity: isResendDisabled ? 0.5 : 1,
                      background: "none",
                      border: "none",
                      color: "#6524EB",
                      fontWeight: "bold",
                      fontSize: "14px",
                    }}
                  >
                    {isResendDisabled && resendTimer > 0
                      ? `Resend One Time Password in ${String(
                        Math.floor(resendTimer / 60)
                      ).padStart(2, "0")}:${String(resendTimer % 60).padStart(
                        2,
                        "0"
                      )}`
                      : "Resend One Time Password"}
                  </button>
                </div>

                {errMsg && (
                  <p
                    className={styles.OTPalreadySent}
                    style={{
                      color: "red",
                      marginTop: "10px",
                      fontWeight: "500",
                    }}
                  >
                    {errMsg}
                  </p>
                )}
                <div className={styles.Btn}>
                  <div type="submit">
                    <div className={styles.btnTheme}>
                      <div
                        className={styles.btn}
                        role="button"
                        tabIndex={0}
                        // Disable click when loading OR OTP not complete
                        onClick={
                          !loading && otp.join("").length === 6
                            ? handleSubmit
                            : undefined
                        }
                        onKeyDown={(e) => {
                          if (
                            !loading &&
                            otp.join("").length === 6 &&
                            (e.key === "Enter" || e.key === " ")
                          ) {
                            handleSubmit();
                          }
                        }}
                        aria-busy={loading}
                        aria-disabled={loading || otp.join("").length !== 6}
                        style={{
                          opacity: otp.join("").length === 6 ? 1 : 0.6,
                          pointerEvents:
                            otp.join("").length === 6 ? "auto" : "none",
                          transition: "opacity 0.3s ease",
                        }}
                      >
                        <img src="Svg/btn-shape.svg" alt="btn-shape" />
                        <p>
                          {loading ? (
                            "Processing…"
                          ) : (
                            <>
                              Verify <b>OTP</b>
                            </>
                          )}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
            {/* Heading */}

            {/* Login link */}
            {/* <p className={styles.login}>
              Already have an account? <a href="#">Log In</a>
            </p> */}

            {/* <p className={styles.login}>No Credit Card Needed</p> */}
            {/* Footer */}
            <p className={styles.footer}>
              No credit card required • Cancel anytime  <br />
              By signing up you agree to our <a href="https://www.rxpt.us/Terms-Condition" target="_blank">Terms & Privacy</a>
            </p>
          </div>
          <div className={styles.ellipsDiv}>
            <div className={styles.elips1}>
              <img src="Svg/Ellipse-yellow.svg" alt="Ellipse-blue" />
            </div>
            <div className={styles.elips2}>
              <img src="Svg/Ellipse-blue.svg" alt="Ellipse-blue" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FreeAccount;
